import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api';
import { useAuth } from '../context/AuthContext';

const STATUS_COLORS = {
  pending:    { bg: '#fef3c7', color: '#92400e' },
  confirmed:  { bg: '#dbeafe', color: '#1e40af' },
  processing: { bg: '#e0e7ff', color: '#3730a3' },
  shipped:    { bg: '#d1fae5', color: '#065f46' },
  delivered:  { bg: '#d1fae5', color: '#065f46' },
  cancelled:  { bg: '#fee2e2', color: '#991b1b' },
};

export default function Orders() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { navigate('/login'); return; }
    api.get('/orders').then(r => {
      setOrders(r.data.orders);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [user, navigate]);

  if (loading) return <div className="spinner" />;

  return (
    <div className="container" style={{ maxWidth: 900 }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: 24 }}>
        <h1 style={{ margin:0 }}>My Orders</h1>
        <Link to="/addresses" className="btn btn-outline btn-sm">&#128205; Saved Addresses</Link>
      </div>

      {orders.length === 0 ? (
        <div className="empty-state">
          <div className="icon">📦</div>
          <h3>No orders yet</h3>
          <p>Once you place an order it will appear here.</p>
          <Link to="/shop" className="btn btn-primary" style={{ marginTop: 16 }}>Start Shopping</Link>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {orders.map(order => {
            const s = STATUS_COLORS[order.status] || STATUS_COLORS.pending;
            return (
              <div key={order.id} style={{
                background: 'white', borderRadius: 12, border: '1px solid #e5e7eb',
                padding: '20px 24px', display: 'flex', justifyContent: 'space-between',
                alignItems: 'center', flexWrap: 'wrap', gap: 12,
              }}>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 4 }}>Order #{order.id}</div>
                  <div style={{ fontSize: 13, color: '#6b7280' }}>
                    {new Date(order.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                  </div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <span style={{ ...s, padding: '4px 14px', borderRadius: 100, fontSize: 13, fontWeight: 600 }}>
                    {order.status.charAt(0).toUpperCase() + order.status.slice(1)}
                  </span>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontWeight: 700, fontSize: 18 }}>${order.total.toFixed(2)}</div>
                  <div style={{ fontSize: 13, color: '#6b7280' }}>{order.subtotal ? `Subtotal $${order.subtotal.toFixed(2)}` : ''}</div>
                </div>
                <Link to={`/orders/${order.id}`} className="btn btn-outline btn-sm">View & Track</Link>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
